import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
//import { SplashScreen } from '@capacitor/splash-screen';
//import { StatusBar, Style } from '@capacitor/status-bar';
/*
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
*/
import { AppComponent } from './app.component';
//import { NavComponent } from '@ionic/core';
import { AppRoutingModule } from './app-routing.module';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Geolocation } from '@capacitor/geolocation'; // new package used here
//import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
//import { IonicStorageModule } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SettingService } from './shared/services/setting.service';
//import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { Tenant404PageComponent } from './pages/tenant-404-page/tenant-404-page.component';
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Browser } from '@capacitor/browser';
import { SharedModule } from './shared/shared.module';
import { LocationsPageComponent } from './pages/locations-page/locations-page.component';
import { LocationsMapComponent } from './components/locations-map/locations-map.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LocationBannerComponent } from './components/location-banner/location-banner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavComponentComponent } from './nav-component/nav-component.component';
//import { ShareButtonsConfig, ShareModule } from '@ngx-share/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReservationComponent } from './reservation-page/pages/reservation-page/reservation-page.component';
import { ReservationConfirmationComponent } from './reservation-confirmation-page/reservation-confirmation-page.component';
import { RedirectPageComponent } from './pages/redirect-page/redirect-page.component';
//import { StoreModule } from './store/store.module';
//import { TermsLandingPageComponent } from './pages/terms-page/terms-page.component';
import { PoliciesLandingPageComponent } from './pages/policies-page/policies-page.component';
import { DataPrivacyContactPageComponent } from './data-privacy-contact/data-privacy-contact-page.component';
//import { NgxCaptchaModule, ReCaptchaV3Service } from 'ngx-captcha';
import { ReservationIframeComponent } from './reservation-page/pages/reservation-iframe/reservation-iframe.component';
import { AuthModule } from './auth/auth.module';
import { MessagesComponent } from './pages/messages/messages.component';
import { AnnouncementsComponent } from './pages/announcements/announcements.component';
//import { MenuService } from './store/services/menu.service';
import { PreloaderService } from './shared/services/preloader.service';

//import { SwiperModule } from 'swiper/angular';


// custom pipes:
//import { TranslatePipe } from './pipes/translate.pipe';

export function app_Init(settingService: SettingService, preloaderService: PreloaderService) {
  return async () => {
    preloaderService.initialize();
    await settingService.initializeApp();
    
  };
}

/*
const customConfig: ShareButtonsConfig = {
  include: ['facebook', 'twitter', 'linkedin', 'reddit', 'whatsapp', 'telegram', 'print', 'email'],
  theme: 'circles-dark',
  autoSetMeta: true,
};
*/


//const ionicConfig = { mode: 'md' };

@NgModule({ declarations: [
        AppComponent,
        //TranslatePipe,
        HomePageComponent,
        LandingPageComponent,
        Tenant404PageComponent,
        LocationsPageComponent,
        LocationsMapComponent,
        LocationBannerComponent,
        NavComponentComponent,
        ReservationComponent,
        ReservationConfirmationComponent,
        RedirectPageComponent,
        //TermsLandingPageComponent,
        PoliciesLandingPageComponent,
        DataPrivacyContactPageComponent,
        ReservationIframeComponent,
        MessagesComponent,
        AnnouncementsComponent
    ],
    exports: [/*TranslateModule,*/ MessagesComponent, AnnouncementsComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [
      BrowserModule,
      IonicModule.forRoot({ mode: 'md' }),
      //ShareModule.withConfig(customConfig),
      //FontAwesomeModule,
      IonicStorageModule.forRoot(),
      /*
      TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
          },
          extend: true,
          isolate: false
      }),
      */
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      BrowserAnimationsModule,
      MatButtonModule,
      MatIconModule,
      MatSortModule,
      MatCheckboxModule,
      MatInputModule,
      MatPaginatorModule,
      MatSelectModule,
      MatDialogModule,
      MatDatepickerModule,
      MatDividerModule,
      MatExpansionModule,
      MatTooltipModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatGridListModule,
      MatNativeDateModule,
      MatListModule,
      AuthModule,
      //NgxCaptchaModule,
      //SwiperModule
    ], 
    providers: [
      Platform,
      //StatusBar,
      //SplashScreen,
      //InAppBrowser,
      //Browser,
      //ReCaptchaV3Service, // Provide the service here
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: APP_INITIALIZER, useFactory: app_Init, deps: [SettingService, PreloaderService], multi: true },
      provideHttpClient(withInterceptorsFromDi()),
      //MenuService
    ]})
export class AppModule {
  /*
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab, far);
  }
  */
}

// required for AOT compilation
/*
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
*/

